var _defs, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgOdooLogo({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Livello_1",
    "data-name": "Livello 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 346 346",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #875a7b;\n      }\n    "))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M173,318c-80.08,0-145-64.92-145-145S92.92,28,173,28s145,64.92,145,145-64.92,145-145,145ZM173,258.07c46.98,0,85.07-38.09,85.07-85.07s-38.09-85.07-85.07-85.07-85.07,38.09-85.07,85.07,38.09,85.07,85.07,85.07Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOdooLogo);
export default __webpack_public_path__ + "static/media/odoo-logo.e0b12b50a50267cc1bd32ec9319e1be7.svg";
export { ForwardRef as ReactComponent };